module.exports = __webpack_public_path__ + "static/media/train14.bef0ba81.png";